import { createRouter, createWebHistory } from 'vue-router'

// Layouts
// import adminRoutes from './admin'

import adminLayout from '@/admin/layouts/LayoutOne.vue'
import neutralLayout from '@/admin/layouts/LayoutTwo.vue'

const routes = [
    // ...adminRoutes,
    {
        path: '/',
        name: 'LandingPage',
        component: () => import('@/admin/modules/website/LandingPage'),
        meta: { layout: neutralLayout }
    },
    {
        path: '/login',
        name: 'LoginPage',
        component: () => import('@/admin/modules/LoginPage'),
        meta: { layout: neutralLayout, isAuthenticated: true }
    },
    {
        path: '/admin/settings',
        name: 'SettingsModule',
        component: () => import('@/admin/modules/auth/SettingsModule'),
        meta: { layout: adminLayout, requiresAuth:true }
    },
    {
        path: '/admin/dashboard/setup',
        name: 'SetupModule',
        component: () => import('@/admin/modules/SetupModule'),
        meta: { layout: adminLayout, requiresAuth:true }
    },
    {
        path: '/:pathmatch(.*)*',
        name: 'notFound',
        component: () => import('@/admin/modules/NotFound.vue'),
        meta: { layout: adminLayout }
    }
]

var router = createRouter({
    history: createWebHistory('/'),
    routes
})


function isLoggedIn()
{
    return localStorage.getItem('token')
}

router.beforeEach((to, from, next) => {
   if(to.matched.some(record => record.meta.requiresAuth)) {
     if(!isLoggedIn()) {
        next({
            name: 'loginPage'
        })
     } else {
        next()
     }
   } else if(to.matched.some(record => record.meta.isAuthenticated)) {
     if(isLoggedIn()) {
        next({
            name: 'dashboardPage'
        })
     } else {
        next()
     }
   } else {
     next()
   }
})

export default router